import React from "react";
import { Margin, P } from "@ovotech/element";

export const StepProgressBar = ({
  currentStep = 1,
  totalSteps = 6,
  stepText = "Step",
}: {
  currentStep?: number;
  totalSteps?: number;
  stepText?: string;
}) => {
  const arrayOfSteps = Array.from({ length: totalSteps });
  const space = "8px";

  return (
    <div
      style={{ width: "100%", overflowX: "hidden" }}
      aria-labelledby="stepper-label"
    >
      <Margin bottom={3}>
        <P id="stepper-label" aria-live="polite" role="status">
          {stepText} {currentStep} of {totalSteps}
        </P>
      </Margin>

      <div
        className="StepContainer"
        data-testid="stepper"
        role="progressbar"
        aria-valuenow={currentStep}
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        title={`Current step is ${currentStep} of ${totalSteps}`}
      >
        {arrayOfSteps.map((_, index) => (
          <div
            className={"Step"}
            aria-current={index + 1 === currentStep}
            key={index}
            style={{
              width: `calc((90% - ${
                totalSteps - 1
              } * ${space}) / ${totalSteps})`,
              height: "2px",
              backgroundColor: `rgba(10, 152, 40, ${
                currentStep < index + 1 ? 0.2 : 1
              })`,
            }}
          />
        ))}
      </div>
    </div>
  );
};
